
export const MESES = [
  { value: '01', name: 'Enero' },
  { value: '02', name: 'Febrero' },
  { value: '03', name: 'Marzo' },
  { value: '04', name: 'Abril' },
  { value: '05', name: 'Mayo' },
  { value: '06', name: 'Junio' },
  { value: '07', name: 'Julio' },
  { value: '08', name: 'Agosto' },
  { value: '09', name: 'Septiembre' },
  { value: '10', name: 'Octubre' },
  { value: '11', name: 'Noviembre' },
  { value: '12', name: 'Diciembre' },
];

export const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= 100; i++) {
    const anio = (currentYear - i);
    years.push({
      value: anio,
      name: anio
    });
  }
  return years;
};

export const generateYearsCPF = () => {
  const anioBase = 17;
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let i = 0; i <= anioBase; i++) {
    const anio = (currentYear - i);
    years.push({
      value: anio,
      name: anio
    });
  }
  return years;
};


export const generateDays = (year, month) => {
  const days = [];
  const lastDay = new Date(year, month, 0).getDate();


  for (let i = 1; i <= lastDay; i++) {
    const day = `0${i}`.substr(-2);
    days.push({
      value: day,
      name: day,
    });
  }

  return days;
};

export const calculatedBirthDate = (year) => {
  const today = new Date();
  const separator = '/';

  return `${`0${today.getDate()}`.substr(-2)}${separator}${`0${today.getMonth() + 1}`.substr(-2)}${separator}${today.getFullYear() - year}`;
};

export const mayoriaDeEdad = (dia, mes, anio) => {
  const hoy = new Date();
  const fechaNac = new Date(`${mes}/${dia}/${anio}`);
  const diffTime = hoy.getTime() - fechaNac.getTime();
  const diffYears = diffTime / (1000 * 3600 * 24 * 365);

  return diffYears >= 18;
};

export const changeDateFormat = (fechaYYYYMMDD) => {
  return fechaYYYYMMDD.split('-').reverse().join('/');
};

export const changeDateFormatT = (fechaYYYYMMDD) => {
  return fechaYYYYMMDD.split('T')[0].split('-').reverse().join('/');
};

export const isFutureDate = (fechaString) =>{
  // Convertir la fecha string en formato dd/mm/yyyy a un objeto Date
  var partesFecha = fechaString.split("/");
  var fecha = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);
  // Obtener la fecha actual
  var fechaActual = new Date();
  // Comparar las fechas y retornar true si la fecha enviada como parámetro es mayor a la actual
  return fecha > fechaActual
}

export const calcularEdad = (fechaNaci) => { //formato dd/mm/yyyy string  se corrige precision de edad segun su cumpleaños
  let dateParts = String(fechaNaci).split('/')
  var fechaNacimiento = new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
  const hoy = new Date();
  const fechaNac = new Date(fechaNacimiento);
  let edad = hoy.getFullYear() - fechaNac.getFullYear();
  const mes = hoy.getMonth() - fechaNac.getMonth();

  if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
    edad--;
  }
  return edad;
}
